(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[746],{

/***/ 5770:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__(3506);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ FAQ; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7850);



var __N_SSG = true;
function FAQ() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: "FAQ",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row justify-content-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-12 col-lg-10 col-xl-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "header mt-md-5",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "header-body",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "header-title display-4",
                                    children: "FAQ"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Was ist HYAPP?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "HYAPP ist eine integrierte Datenplattform, auf der Sie Controlling- und Workflow-Tools von verschiedenen Anbietern f\xfcr Ihr Krankenhaus nutzen k\xf6nnen. Dabei werden die Tools nicht nur zentral angeboten und bereitgestellt, sondern \xfcber unser innovatives Datenmodell miteinander vernetzt, so dass redundante Datenbearbeitungen entfallen."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "Was f\xfcr einen Nutzen habe ich als HYAPP Kunde?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Sie stellen sich eine Auswahl der besten auf dem Markt verf\xfcgbaren Controlling-Tools individuell zusammen und k\xf6nnen diese zentral f\xfcr Ihr Klinikmanagement nutzen. Neben der vereinfachten Datenbearbeitung erhalten Sie durch unseren umfangreichen Datenpool zudem Zugriff auf einen umfassenden Benchmark sowie Freemium-Tools."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "Warum sollte ich HYAPP nutzen?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Sie sollten HYAPP nutzen, wenn Sie unn\xf6tige Datenverarbeitungs-Schritte reduzieren, Zeit und Ressourcen sparen und Mehrwert durch neueste Tools und Analyse-Software f\xfcr Ihr Klinikmanagement generieren wollen."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "Ben\xf6tige ich eine bestimmte Software"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Alles was Sie brauchen ist ein aktueller Browser (Google Chrome, Firefox) und die g\xe4ngigen MS Office Anwendungen."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "Welche Voraussetzungen m\xfcssen gegeben sein?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Sie sollten als Vertreter Ihres Krankenhauses kaufberechtigt sein bzw. die Freigabe der Gesch\xe4ftsf\xfchrung sollte vorliegen."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "Wie lange kann ich die Apps nutzen?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Die ausgew\xe4hlten Apps stehen Ihnen je nach Vertragsgestaltung unbegrenzt bis zur K\xfcndigung zur Verf\xfcgung."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "K\xf6nnen die Apps veralten?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Alle Partner der HYAPP stellen sicher, dass die angebotenen Apps dem neuesten Stand entsprechen und regelm\xe4\xdfig aktualisiert werden. \xdcber Software-Aktualisierungen werden Sie per E-Mail informiert. Cloud-basierte Apps aktualisieren sich automatisch."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "Muss ich mich f\xfcr jede App extra anmelden?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "HYAPP nutzt ein Single Sign-On Verfahren. Somit k\xf6nnen Sie, mit einem Konto, auf alle erworbenen Apps auf HYAPP zugreifen."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "Gibt es eine Laufzeit/Vertragsbindung?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Die Laufzeit betr\xe4gt ein Jahr und verl\xe4ngert sich automatisch um ein weiteres Jahr, sofern nicht innerhalb der 3 monatigen Frist eine K\xfcndigung erfolgt."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "Wo finde ich Hilfe?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            children: [
                                "Auf der Plattform gibt es eine ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    href: "/contact",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "text-secondary",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                            children: "Kontaktseite"
                                        })
                                    })
                                }),
                                ", \xfcber die Sie bei allgemeinen Fragen Unterst\xfctzung finden. Bei App-spezifischen Fragen k\xf6nnen Sie auf der jeweiligen App-Seite direkt mit dem App-Anbieter in Kontakt treten."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "Wie schnell bekommt man Analyseergebnisse von einzelnen Anwendungen?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Die Analysen laufen \xfcberwiegend in Echtzeit und sind abh\xe4ngig von der jeweiligen App. Bei Verwendung der App wird \xfcber eine Skala der berechnete Zeitaufwand angezeigt."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "Wie kann ich Fragen zu meinen Analyseergebnissen platzieren und Unterst\xfctzung bei der Interpretation erhalten?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Bei Fragen zu Analyseergebnissen k\xf6nnen Sie sich \xfcber die Chat-Funktion an einen unserer erfahrenen Berater wenden, der sie ach gerne mit weiteren Experten vernetzt."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "Wo kann ich eigene Vorschl\xe4ge und Ideen zu neuen Analysetools und Verkn\xfcpfungen von Datenstrukturen machen?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            children: [
                                "Wir freuen uns \xfcber Anregungen, Verbesserungen und Feedback \xfcber die ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    href: "/contact",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "text-secondary",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                            children: "Kontaktseite"
                                        })
                                    })
                                }),
                                " und setzen uns dann zeitnah mit Ihnen in Verbindung."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "Wie kann man einen Berater buchen?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            children: [
                                "Wir verf\xfcgen \xfcber ein gro\xdfes Netzwerk an erfahrenen Beratern mit langj\xe4hriger Expertise im Krankenhausmanagement. Schreiben Sie uns gerne an \xfcber die ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    href: "/contact",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "text-secondary",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                            children: "Kontaktseite"
                                        })
                                    })
                                }),
                                " und wir melden uns bei Ihnen."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "pt-4",
                            children: "Welche Daten brauche ich f\xfcr die Apps?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Die f\xfcr die jeweilige App erforderlichen Daten k\xf6nnen Sie der App-Detailseite entnehmen. Bei Kauf einer App wird diese detailliert beschrieben."
                        })
                    ]
                })
            })
        })
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [706,850,774,888,179], function() { return __webpack_exec__(5770); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);